import type EmailRemindersStore from './schema/EmailRemindersStore';
import { createStore } from 'satcheljs';

const defaultEmailRemindersStore: EmailRemindersStore = {
    showDialog: false,
    draftReminder: null,
    newReminderIdMap: {},
    customReminderDate: null,
};

export const getStore = createStore<EmailRemindersStore>(
    'emailReminders',
    defaultEmailRemindersStore
);
export default getStore();
